<template>
  <div class="bg_gray">
    <div class="fixed">
      <div class="top_header">
        <div class="m_flex_box flex_vc flex_jz">
          <div class="m_flex_box flex_vc">
            <van-icon name="arrow-left" class="mar_r" @click="goback" size='0.4rem'/>
            <div class="search_con m_flex_box flex_vc">入网须知</div>
          </div>
        </div>
      </div>
    </div>
    <div class="fixed_pad"></div>
    <div class="">
      <ul class="infoList">
        <li>
          <span class="key">开发企业新入网须知</span>
          <span class="mark" @click="newNotice"></span>
        </li>
        <li>
          <span class="key">开发企业入网变更须知</span>
          <span class="mark" @click="changeNotice"></span>
        </li>
      </ul>
    </div>
    <div class="tip">
      为了您顺利办理业务，请仔细阅读须知内容，提前准备相应材料
    </div>
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "enterpriseNotice",
  data() {
    return {};
  },
  mounted() {},
  methods: {
    goback() {
      this.$router.go(-1);
    },
    newNotice() {
      this.$router.push({
        path: "/newAccessInternet",
      });
    },
    changeNotice() {
      this.$router.push({
        path: "/changeAccessInternet",
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "MechanismDetail") {
      this.$store.dispatch("saveView", ["AnnounceMechanism"]).then(() => {
        next();
      });
    } else {
      this.$store.dispatch("saveView", []).then(() => {
        next();
      });
    }
  },
};
</script>
<style lang="less" scoped>
.fixed_pad {
  padding-top: 1.1rem;
}
.bg_gray {
  min-height: 100vh;
  background-color: #ffffff;
}
.fixed {
  border-bottom: 1px solid #f5f5f5;
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9;
  .top_normal {
    height: 100%;
    i {
      font-size: 0.32rem;
    }
  }
}
.top_header {
  height: 0.7rem;
  padding: 0.1rem 0rem;
  width: 7.04rem;
  margin: 0 auto;
  &.top_sm {
    padding: 0.1rem;
  }
  .search_con,
  .search_con_l {
    height: 0.7rem;
    box-sizing: border-box;
    font-size: 0.3rem;
    padding: 0 0.3rem;
    color: #303030;
    i {
      font-size: 0.36rem;
      margin-right: 0.2rem;
    }
  }
  input {
    width: 80%;
    height: 0.7rem;
    background-color: transparent;
  }
  .search_con {
    font-weight: bolder;
    justify-content: center;
    width: 5.78rem;
  }
  .search_con_l {
    width: 5.72rem;
  }
  .to_map {
    font-size: 0.28rem;
    img {
      margin-right: 0.06rem;
      width: 0.32rem;
      height: 0.32rem;
    }
  }
}
.infoList {
  padding-top: 0.2rem;
  padding-left: 0.2rem;
  li {
    font-size: 0.3rem;
    height: 1rem;
    border-bottom: 1px solid #efefef;
    position: relative;
    padding-right: 0.5rem;
    color: #606060;
    padding-left: 0.5rem;
    .key {
      line-height: 1rem;
    }
    .mark {
      position: absolute;
      left: 0;
      top: 0;
      right: 0.5rem;
      height: 100%;
      &:after {
        font-family: "iconfont" !important;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -webkit-text-stroke-width: 0.2px;
        -moz-osx-font-smoothing: grayscale;
        content: ">";
        position: absolute;
        right: 0;
        color: #606060;
        top: 0;
        line-height: 1rem;
        font-size: 0.4rem;
      }
    }
  }
}

.tip {
  color: #ccc;
  font-size: 0.3rem;
  position: absolute;
  bottom: 1rem;
  left: 0;
  padding: 0 1rem;
  text-align: center;
}
</style>